<template>
	<v-container fluid>
		<s-crud :config="config" title="Parihuelas Abastecidas" :filter="filter" search-input
			@rowSelected="rowSelected($event)" ref="scrudPar">
			<template v-slot:options v-if="$fun.isAdmin()">
				<v-tooltip bottom="">
					<template v-slot:activator="{ on }">
						<v-btn text small v-on="on" @click="deleteEvent(item)"> <v-icon
								style="font-size:18px;">mdi-minus-circle-outline</v-icon></v-btn>
					</template>
					<span>Eliminar</span>
				</v-tooltip>
			</template>

			<template v-slot:filter>
				<v-container>
					<v-row justify="center">
						<v-col cols="6" lg="3" md="3">
							<s-date label="Fecha Inicio" v-model="filter.BeginDate"></s-date>
						</v-col>
						<v-col cols="6" lg="3" md="3">
							<s-date label="Fecha Fin" v-model="filter.EndDate"></s-date>
						</v-col>

						<v-col cols="6" lg="3" md="3">
							<s-select-definition :def="1181" label="Destino"
								v-model="filter.TypeDestiny"></s-select-definition>
						</v-col>
					</v-row>
				</v-container>
			</template>

			<template v-slot:RcfID="{ row }">
				<v-chip small dark outlined :color="'blue'">
					{{ row.RcfID }}
				</v-chip>
			</template>
		</s-crud>
	</v-container>
</template>

<script>
import _sSupplying from "../../../services/FreshProduction/SupplyingOfLotsService";

export default {
	components: {},
	data() {
		return {
			item: {},
			config: {
				service: _sSupplying,
				model: {
					SppID: "ID",
				},
				headers: [
					{ text: "Parihuela", value: "LlpID", width: 100 },
					{ text: "Lote Producción", value: "RcfID", width: 200 },
					{ text: "Calibre", value: "TypeCaliberName", width: 100 },
					{ text: "Cant. Jabas", value: "SppQuantityJaba", width: 100 },
					{ text: "Tipo Cultivo", value: "TypeCropName", width: 100 },
					{ text: "Cultivo", value: "TypeCultiveName", width: 100 },
					{ text: "Variedad", value: "VrtName", width: 100 },
				]
			},
			filter: {
				BeginDate: null,
				EndDate: null,
				TypeDestiny: 0
			}
		};
	},
	methods: {
		deleteEvent(item) {
			this.$fun.alert("Seguro que desea eliminar ?", "question").then(r => {
				if (r.value) {
					_sSupplying.save(item.SppID, this.$fun.getUserID()).then(r => {
						if (r.status == 200) {
							this.$fun.alert("Eliminado correctamente", "success");
							this.$refs.scrudPar.refresh();
						}
					});
				}
			})
			// _sSupplying.save(item.SppID, this.$fun.getUserID()).then(r => {
			// 	if (r.status == 200) {
			// 		this.$fun.alert("Eliminado correctamente", "success");
			// 	}
			// })
		},
		rowSelected(rows) {
			if (rows.length > 0) {
				this.item = rows[0];
			}
		},
	},
};
</script>
